export default "__VITE_ASSET__wQzi7Hiu__"